import { get } from 'lodash';
import { css } from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { theme } from 'modules/tetrisTheme';
import { cssPropertyThemeKey } from './cssPropertyToThemeKey';
import { valueGuard } from './valueGuard';
/**
 * media query helper. Styles will be applied to the breakpoint and larger.
 *
 * `base` is the default and will apply where no breakpoint matches.
 *
 * @example
 * responsiveProperty('padding', '1rem');
 *
 * responsiveProperty('padding', {
 *   base: `0`,
 *   sm: `1rem`,
 *   lg: `2rem`,
 * });
 *
 */
export function responsiveProperty(property, values) {
    if (!values) {
        return css ``;
    }
    const mappableValues = valueGuard(values);
    const themeScale = cssPropertyThemeKey(property);
    const arrayValues = Object.entries(mappableValues).reduce((acc, [key, value]) => {
        // Color paths are already rooted at the theme (`semantic.…`, `swatches.…`); other scales are relative
        const path = themeScale === 'colors' ? value : `${themeScale}.${value}`;
        // A value that names a theme token (e.g. `padding: 'xl'`) resolves to its CSS variable
        const token = get(theme, path);
        const cssValue = (typeof token === 'string' ? token : value);
        if (key === 'base') {
            return Object.assign(Object.assign({}, acc), { [property]: cssValue });
        }
        const breakpoint = breakpoints[key];
        return Object.assign(Object.assign({}, acc), { [breakpoint]: {
                [property]: cssValue,
            } });
    }, {});
    return css(arrayValues);
}
